import { render, staticRenderFns } from "./TablaPaginada.vue?vue&type=template&id=2bbc0dec&"
import script from "./TablaPaginada.vue?vue&type=script&lang=js&"
export * from "./TablaPaginada.vue?vue&type=script&lang=js&"
import style0 from "./TablaPaginada.vue?vue&type=style&index=0&id=2bbc0dec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports